<template>
  <div
    class="oct-form__col"
    :class="[{
      'oct-form__col--dense': dense
    },`oct-form__col--${columnWidth}`]"
  >
    <slot />

    <!--
      @event 'increase'
      @event 'decrease'
    -->
    <oct-amount-selector
      class="oct-form-col__action"
      :reducible="reducible"
      @increase="$emit('increase')"
      @decrease="$emit('decrease')"
      v-if="removable"
    >
      <!-- Delegate the helper slot to the button component -->
      <template #helper>
        <slot name="helper" />
      </template>
    </oct-amount-selector>
  </div>
</template>

<script>
import OctAmountSelector from '@/components/amount-selector/OctAmountSelector.vue';

export default {
  name: 'OctFormCol',
  components: { OctAmountSelector },
  props: {
    /** Number of column */
    cols: {
      type: Number,
      default: 12
    },
    /** Dense or not */
    dense: {
      type: Boolean,
      default: false
    },
    /** Whether removable */
    removable: {
      type: Boolean,
      default: false
    },
    /** Whether can reduce */
    reducible: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    columnWidth () {
      return !this.cols ? 0 : 12/this.cols
    }
  }
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-form__col {
  position: relative;
  margin: 0 0 oct-rem(12);
  display: flex;
  flex: 0 0 auto;
  padding: 0 oct-rem(12);

  &--dense {
    padding: 0 oct-rem(6);

    &:first-child {
      margin-left: oct-rem(6);
    }

    &:last-child {
      margin-right: oct-rem(6);
    }
  }
  
  &--0 {
    flex: 1 1 auto;
  }

  &--3 {
    flex: 0 0 50%;
  }

  &--6,
  &--9 {
    flex: 0 0 100%;
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  position: relative;
  margin: 0 0 oct-rem(12);
  display: flex;
  flex: 0 0 auto;
  padding: 0 oct-rem(12);

  &--dense {
    padding: 0 oct-rem(6);

    &:first-child {
      margin-left: oct-rem(6);
    }

    &:last-child {
      margin-right: oct-rem(6);
    }
  }
  
  &--0 {
    flex: 1 1 auto;
  }

  &--3 {
    flex: 0 0 25%;
  }

  &--6 {
    flex: 0 0 50%;
  }

  &--7 {
    flex: 0 0 (100%*7/12);
    width: (100%*7/12);
  }

  &--8 {
    flex: 0 0 (100%*8/12);
    width: (100%*8/12);
  }

  &--9 {
    flex: 0 0 (100%*9/12);
    width: (100%*9/12);
  }

  &--12 {
    flex: 0 0 100%;
    width: 100%
  }
}
}

.oct-form-col__action {
  position: absolute;
  top: 50%;
  left: 100%;
  transform: translateY(-50%);
}
</style>
